import React, { Fragment } from 'react';
import { CheckCircle, Cancel } from '@mui/icons-material';
import LoadingIndicator from '../../../LoadingIndicatorMaterial/LoadingIndicator';
import NotificationLabel from '../NotificationLabel/NotificationLabel';

function ProgressIndicator({
  isSaving,
  hasError,
  savingMsg = 'Saving, please wait...',
  errorMsg = 'There was an error.  Please try again.',
  isSuccessful = false,
  successMsg = 'Success!',
  testId = 'progess-indicator-error',
}) {
  return isSaving || hasError || isSuccessful ? (
    <div className="absolute bottom-0 left-0 w-100 overflow-hidden fs-14 lh-16 fw3 bg-white">
      <NotificationLabel
        {...{
          isSaving,
          hasError,
          isSuccessful,
          testId,
        }}
      >
        {isSaving && (
          <Fragment>
            <LoadingIndicator isLoading customStyle={{ height: 18 }} size={18} />
            <span className="ml2">{savingMsg}</span>
          </Fragment>
        )}

        {hasError && (
          <Fragment>
            <Cancel />
            <span className="ml2 truncate overflow-hidden" title={errorMsg}>
              {errorMsg}
            </span>
          </Fragment>
        )}

        {isSuccessful && (
          <Fragment>
            <CheckCircle className="limeade" />
            <span className="ml2">{successMsg}</span>
          </Fragment>
        )}
      </NotificationLabel>
    </div>
  ) : (
    <></>
  );
}

export default ProgressIndicator;
